import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import AttachFileIcon from '@material-ui/icons/AttachFile';
import GetAppIcon from '@material-ui/icons/GetApp';
import IconButton from '@material-ui/core/IconButton';

import LinearProgress from '~/components/LinearProgress';

import Dialog from '~/components/Dialog';
import ImageZoomViewer from '~/components/ImageZoomViewer';

import Request from '~/providers/Request';
import { URL } from '~/config/uri';

function ShowDoc({ isOpen, file, handleClose }) {
  const [loading, setLoading] = useState(false);
  const [fileShow, setFileShow] = useState(null);
  const [isImage, setIsImage] = useState(false);

  const fileName = (file && file.name) || 'anexo';

  useEffect(() => {
    let objectUrl;

    async function showFile() {
      setLoading(true);
      const authorizationToken = await Request.getAuth();
      const response = await fetch(`${URL}/admin/doc/${file.id}`, {
        method: 'GET',
        headers: new Headers({ Authorization: `Bearer ${authorizationToken}` }),
      });
      const blob = await response.blob();
      objectUrl = window.URL.createObjectURL(blob);
      const byType = (blob.type || '').startsWith('image/');
      const byName = /\.(jpe?g|png|gif|bmp|webp)$/i.test(fileName);
      setIsImage(byType || byName);
      setFileShow(objectUrl);
      setLoading(false);
    }

    if (isOpen && file) {
      showFile();
    }

    return () => {
      if (objectUrl) window.URL.revokeObjectURL(objectUrl);
    };
  }, [isOpen, file]);

  function handleDownload() {
    if (!fileShow) return;
    const a = document.createElement('a');
    a.href = fileShow;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    a.remove();
  }

  return (
    <Dialog
      icon={<AttachFileIcon />}
      isOpen={isOpen}
      handleClose={handleClose}
      title={fileName}
      headerActions={
        <IconButton
          color="inherit"
          onClick={handleDownload}
          disabled={!fileShow}
          aria-label="Download"
        >
          <GetAppIcon />
        </IconButton>
      }
    >
      <>
        <LinearProgress loading={loading} />

        {!loading && fileShow && (
          isImage ? (
            <ImageZoomViewer src={fileShow} alt={fileName} />
          ) : (
            <embed
              src={fileShow}
              width="100%"
              height="100%"
              style={{ minHeight: '72vh' }}
            />
          )
        )}
      </>
    </Dialog>
  );
}

ShowDoc.propTypes = {
  id: PropTypes.number.isRequired,
  isOpen: PropTypes.bool.isRequired,
  file: PropTypes.object,
};

ShowDoc.defaultProps = {
  id: null,
  file: null,
  isOpen: false,
};

export default ShowDoc;
